import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/_services/loading.service';
import { GlobalContentService } from '../../_ecomservices/global-content.service';
import { NotificationService } from 'src/app/_services/notification.service';

@Component({
  selector: 'app-global-content',
  templateUrl: './global-content.component.html',
  styleUrls: ['./global-content.component.css']
})
export class GlobalContentComponent implements OnInit {

  constructor(
    public globalContentService: GlobalContentService,
    private loading: LoadingService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.onLoadGlobalContent();
  }

  onLoadGlobalContent() {
    // console.log('ok');
    var result = this.globalContentService.get_global_content().subscribe((data: any) => {
      console.log(data);
      this.loading.spin$.next(true);
      this.globalContentService.global_content_form.patchValue({
        id: data.id,
        header_content: data.head,
        body_content: data.body,
        footer_content: data.footer,
      });
      this.loading.spin$.next(false);
    });
  }

  onGlobalContentFormSubmit() {
    if (this.globalContentService.global_content_form.valid) {
      this.loading.spin$.next(true);
      this.globalContentService.update_global_content(this.globalContentService.global_content_form.value).subscribe(data => {
        console.log(data);
        if (data['status']) {
          this.notificationService.success(data['message']);
          this.loading.spin$.next(false);
        }
        else {
          this.notificationService.error(data['message']);
          this.loading.spin$.next(false);
        }
      });
    }
  }

}
